// extracted by mini-css-extract-plugin
export var audioPlayer = "_o4-0";